export default "__VITE_ASSET__CCBwF_vn__"